import React from 'react';
import { Services } from '../components/Services';
export function ServicesPage() {
  return <div className="pt-24 min-h-screen" data-id="element-231">
      <Services data-id="element-232" />
    </div>;
}